import { Basket } from '@frontend/basket/types';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

interface ViewProps {
    account_id: string | null;
    onCancel: () => void;
    onSubmitSuccess: (basket: Basket) => void;
}

const useBasketCreate = (): ViewProps => {
    const navigate = useNavigate();
    const { currentAccount } = useAccountRepository();

    const onCancel = () => {
        navigate('/baskets');
    };

    const onSubmitSuccess = (basket: Basket) => {
        navigate(`/accounts/${basket.account_id}/baskets/${basket.id}/detail`);
    };

    return {
        account_id: currentAccount,
        onCancel,
        onSubmitSuccess
    };
};

export default useBasketCreate;
